import {FeedbackUserType} from "../../redux/survey/survey.types";
import {formatDisplayDateTime} from "../../helpers/date.helpers";

interface TextBubbleProps {
  createdAt?: string;
  feedback: string;
  userType: FeedbackUserType;
  useRedesign?: boolean;
}

const TextBubble = ({ feedback, createdAt, userType, useRedesign = false }: TextBubbleProps) => {
  const userTypeText = userType === 'ai' ? 'Invisibly AI Panelist' : 'Human';

  const bubbleClasses = useRedesign ? 'border border-status-gray' : 'rounded-ss-none';
  const textClasses = useRedesign ? 'text-sm' : 'text-base';
  const helperTextClasses = useRedesign ? 'text-black font-medium' : 'text-status-gray';
  return (
    <div className={`flex shrink lg:max-w-[66%]`}>
      {/* this flex-shrink will only shrink if it's not wrapped. flex-wrap takes precedence so if
          the content doesn't extend to the end of the line, it will feel like there's wasted space */}
      <div className={`flex flex-col shrink gap-2 rounded-xl px-4 py-3 bg-gray-200 ${bubbleClasses}`}>
        <span className={textClasses}>
          {feedback}
        </span>
        <span className={`flex text-xs ${helperTextClasses}`}>
          { createdAt && (
            <>
              {formatDisplayDateTime(createdAt)}
              {' '}
              -
              {' '}
            </>
          )}
          {userTypeText}
        </span>
      </div>
    </div>
  );
};

export default TextBubble;
